import { render, staticRenderFns } from "./RolesAutocomplete.vue?vue&type=template&id=751963b4"
import script from "./RolesAutocomplete.ts?vue&type=script&lang=ts&external"
export * from "./RolesAutocomplete.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports